<template>
  <v-card flat>
    <content-detail v-for="(contentReason, index) in contentReasons"
      :key="index"
      :items="getItems(contentReason)"
      :all-prizes="allPrizes"
      :compressed="compressed"
      :row-type="getRowType (contentReason)"
      :item-type="itemType"
    ></content-detail>
  </v-card>
</template>
<script>
import { SearchUtils } from '@/js'
import Contentdetail from '@/components/Contentdetail'
export default {
  props: {
    rowTypes: {
      type: Array,
      requireed: true
    },
    item: Object,
    compressed: Boolean,
    allPrizes: Array
  },
  components: {
    'content-detail': Contentdetail
  },
  methods: {
    getItems (contentReason) {
      return contentReason.reasons
    },
    getRowType (contentReason) {
      return contentReason.rowType
    }
  },
  computed: {
    itemType () {
      return this.item.itemType
    },
    contentReasons () {
      if (!this.item) return []
      return this.rowTypes.map(rowType => {
        // filter out the items for this type
        const reasons = SearchUtils.filterReasons(this.item, rowType)

        // if its coompressed, then all the reasons come on a single row so delegate that
        if (this.compressed) {
          return {
            reasons,
            rowType
          }
        }

        // if its not compressed then we have to blow out the reasons to 1 per line
        const flat = reasons.reduce((p, c) => {
          c.MatchReasons.forEach(f => {
            p.push({
              itemType: f.matchType,
              itemID: f.matchID,
              itemName: f.match,
              itemReason: f,
              MatchReasons: [f]
            })
          })
          return p
        }, [])
        return {
          reasons: flat,
          rowType
        }
      })
    }
  }
}
</script>
